<template>
  <div class="flex flex-column justify-center">
    <div class="flex justify-center w-100 h-100 pt3">
      <img class="slideInfoImg" :src="img">
    </div>
    <div class="ph3 self-center">
      <p class="tc silver" >{{text}}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'slide-info',
  props: {
    text: {
      required: true
    },
    img: {
      required: true
    }
  }
}
</script>

<style>
  .slideInfoImg {
    max-width: 20%;
  }
</style>



// WEBPACK FOOTER //
// src/components/modals/subscription/SlideInfo.vue